var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF2F4",
    d: "m14.2 5-2.9-2.9a.95.95 0 0 1-.276-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.426 0 .7.275l4.6 4.6q.15.15.213.325.062.176.062.375 0 .2-.062.375a.9.9 0 0 1-.213.325l-4.6 4.6a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L14.2 7H1a.97.97 0 0 1-.712-.288A.97.97 0 0 1-.001 6q0-.424.288-.713A.97.97 0 0 1 .999 5z"
  })));
};
export default SvgArrowRight;